<!-- begin: Header -->
@if (shouldDisplayTrialHeader) {
  <div class="trial-header">
    <div class="trial-days-container">
      <span class="trial-days">{{ trialDays }}</span>
    </div>
    <span i18n="@@global.trial-days-left-message">
      days left till free trial ends. Upgrade now to continue your experience
      with ALL PRO features!</span
    >
    <button (click)="handleUpgradeButton()" i18n="@@global.Upgrade">
      <span>Upgrade</span>
    </button>
  </div>
}
<div
  ktHeader
  #ktHeader
  class="kt-header kt-grid__item"
  [ngClass]="htmlClassService.getClasses('header', true)"
  id="kt_header"
>
  @if ((loader.progress$ | async) > 0) {
    <ngb-progressbar
      class="kt-loading-bar"
      [value]="loader.progress$ | async"
      height="3px"
    ></ngb-progressbar>
  }

  <kt-banner></kt-banner>

  <div class="kt-container" [ngClass]="{ 'kt-container--fluid': fluid }">
    <!-- begin:: Brand -->
    <kt-brand></kt-brand>
    <!-- end:: Brand -->
    @if (shouldShowLoginButton) {
      <div
        class="d-flex align-items-center w-100 justify-content-end"
        style="height: 56px !important"
      >
        <button
          class="login-button primary"
          i18n="@@header.log-in"
          (click)="redirectToLogin()"
        >
          Log In
        </button>
      </div>
    }

    <!-- begin: Header Menu -->
    @if (menuHeaderDisplay) {
      <kt-menu-horizontal [isWalletApp]="isWalletApp"></kt-menu-horizontal>
    }
    <!-- end: Header Menu -->

    <!-- begin:: Header Topbar -->
    <!-- empty div to fix topbar to stay on the right when menu-horizontal is hidden -->
    @if (!menuHeaderDisplay) {
      <div></div>
    }
    <div class="d-flex" data-intercom-target="Topbar_Container">
      <kt-topbar></kt-topbar>
    </div>
    <!-- end:: Header Topbar -->
  </div>
</div>
<!-- end: Header -->
